import type { RohsComponentComplianceFileView } from '@/shared/hooks/api/rohsComplianceFiles'

/** Linked parts that require RoHS evidence (excludes IDLE slots). */
export function trackedRohsParts(
  components: RohsComponentComplianceFileView[]
): RohsComponentComplianceFileView[] {
  return components.filter((part) => part.status !== 'IDLE')
}
